import React from 'react';
import { connect } from 'react-redux';
import { ToastContainer } from 'react-toastify';

import Header from './Header';
import Navigation from '../navigation/components/Navigation';
import Footer from './Footer';
import Shortcut from '../navigation/components/Shortcut';

import {
  requestUserInfo,
  logout,
  changeLocation,
  changeTenant
} from '../../store/current-user/CurrentUserActions';
import { requestLocations } from '../../store/locations/LocationsActions';
import { requestTenants } from '../../store/tenant/TenantActions';
import { requestCptReview } from '../../store/visit-notes/VisitNotesActions';
import {
  isSuperAdmin,
  isAdministrativeProvider,
  isSupervisingPhysician,
  isAdmin,
  isExecutive,
  isClinician,
  isClinicalStaff,
  isPhysiciansAssistant,
  isClinicalPharmacist,
  isManager,
  isStaff,
  isExternalStakeholder,
  isOrganizationalClient,
  isPatientAdvocate,
  isClinicalComplianceManager,
  isClinicalOperationsManager,
  isCareNavigator,
  isMakoAdmin,
  isMakoUser
} from '../../store/current-user/CurrentUserSelectors';

class Layout extends React.Component {
  componentWillMount() {
    this.props.getCurrentUser();
    this.fetchNotes();
    this.props.getLocations({
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getTenants();
    this.props.user.queryParams.tenantId = ((localStorage.getItem('tenant') === null) ? this.props.user.queryParams.tenantId : localStorage.getItem('tenant'));
  }


  componentDidUpdate() {
    const {
      user: { error, data },
      logout,
    } = this.props;
    if (error) {
      logout();
    } else if (data && !data.isActive) {
      logout('Your account has not been activated.');
    }
  }

  fetchNotes = (page = 0, perPage = 25, order = 'desc dateOfService', search = '', filters = '', params = {}) => {
    return this.props.getCptReview({
      offset: page * perPage,
      limit: perPage,
      order,
      search,
      filters,
      ...params,
      ...this.props.user.queryParams
    });
  };

  render() {
    const { user, locations, tenants, checks, cpt, logout, changeLocation, changeTenant } = this.props;
    const clientsToShow = user.data ? user.data.clients : null;
    const locationsToShow = user.data ? user.data.clinics : null;
    const isWorkLocationAssigned = user.data ? user.data.isWorkLocationAssigned : null;

    return (
      <div>
        {user.data && (
          <div>
            <Header
              locations={checks.isClinicalStaff ? locationsToShow : locations}
              tenants={checks.isSuperAdmin ? tenants : []}
              logout={logout}
              checks={checks}
              user={user}
              changeLocation={changeLocation}
              changeTenant={changeTenant}
            />
            <Navigation checks={checks} clients={clientsToShow} locations={locationsToShow} cptTotal={cpt.total} isWorkLocationAssigned={isWorkLocationAssigned} />
            <div id="main" role="main">
              {this.props.children}
            </div>

            <Footer />
            <Shortcut checks={checks} />
          </div>
        )}
        {user.isLoading && (
          <div className="layout-spinner">
            <div className="spinner" />
          </div>
        )}
        <ToastContainer />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.currentUser,
  locations: state.locations.list,
  tenants: state.tenant.list,
  cpt: state.visitNotes.cptdata,
  checks: {
    isSuperAdmin: isSuperAdmin(state),
    isAdministrativeProvider: isAdministrativeProvider(state),
    isSupervisingPhysician: isSupervisingPhysician(state),
    isAdmin: isAdmin(state),
    isExecutive: isExecutive(state),
    isClinician: isClinician(state),
    isClinicalStaff: isClinicalStaff(state),
    isPhysiciansAssistant: isPhysiciansAssistant(state),
    isClinicalPharmacist: isClinicalPharmacist(state),
    isManager: isManager(state),
    isStaff: isStaff(state),
    isExternalStakeholder: isExternalStakeholder(state),
    isOrganizationalClient: isOrganizationalClient(state),
    isPatientAdvocate: isPatientAdvocate(state),
    isClinicalComplianceManager: isClinicalComplianceManager(state),
    isClinicalOperationsManager: isClinicalOperationsManager(state),
    isCareNavigator: isCareNavigator(state),
    isMakoAdmin: isMakoAdmin(state),
    isMakoUser: isMakoUser(state),
  },
});
const mapDispatchToProps = dispatch => {
  return {
    getCurrentUser: () => dispatch(requestUserInfo()),
    logout: msg => dispatch(logout(msg)),
    getLocations: (params) => dispatch(requestLocations(params)),
    getTenants: () => dispatch(requestTenants()),
    changeLocation: (id) => dispatch(changeLocation(id)),
    changeTenant: (id) => dispatch(changeTenant(id)),
    getCptReview: params => dispatch(requestCptReview(params)),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Layout);



// WEBPACK FOOTER //
// ./src/components/common/Layout.js